import { Component, HostBinding, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { ScrudgService } from '../../../services/base/scrudg/scrudg.service';
import { ActionButton } from '../../../models/app/action-button';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { MessageSeverity } from '../../../enums/message-severity';
import { HttpErrorResponse } from '@angular/common/http';
import { DeleteResult } from '../../../models/net/result/crud/delete-result';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UtilityFunctions } from '../../../utilities/utility-functions';
import { SearchPreference } from '../../../models/data/app-core/search-preference';
import { PersonService } from '../../../services/persons/person.service';
import { SearchRequest } from '../../../models/data/app-core/search-request';
import { SearchRequestTypeEnum } from '../../../enums/search-request-type-enum';
import { SessionService } from '../../../services/session/session.service';
import { TelemetorComponent } from '../telemetor/telemetor.component';
import { TelemetryService } from '../../../services/telemetry/telemetry.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})

export class SearchComponent extends TelemetorComponent implements OnInit, OnDestroy {

    public itemRoute: string = "";
    public itemTypeName: string = "";
    public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.Unknown;
    public searchRequest: any = null;
    public searchResultDatasource: any = null;
    public searchResult: any = [];
    public isSearchMarqueeDisabled: boolean = true;

    @HostBinding("class.component-flex-vertical-fill") addClass = true;
    @ViewChild(MatSort) sort = new MatSort();

    private destroy = new Subject<void>();

    public constructor(public appService: AppService,
                       public sessionService: SessionService, 
                       public itemService: ScrudgService,
                       @Inject("") itemRoute: string,
                       @Inject("") itemTypeName: string) {

        super(); // telemetryService);

        this.itemRoute = itemRoute;
        this.itemTypeName = itemTypeName;

        // setup actions
        let actionButtons: ActionButton[] = [];

        actionButtons.push(new ActionButton("NEW " + UtilityFunctions.splitByCapitalLetters(this.itemTypeName).toUpperCase(), "add", "new", "", false));
        //actionButtons.push(new ActionButton("APP FEED", "", "", "", false));

        this.appService.setActionsDataSource(actionButtons);

        this.appService.actionButtonClicked.pipe(takeUntil(this.destroy)).subscribe((actionName: string) => {

            switch (actionName) {

                case "search":

                    this.search();

                    break;

                case "new":

                    this.newItem();

                    break;
            }
        });
    }

    public override ngOnInit(): void {

        this.appService.getSearchPreference(this.searchRequestTypeEnum).subscribe((searchPreference: SearchPreference | null) => {

            if (searchPreference) {

                this.handleSearchPreference(searchPreference);
            }
        });

        this.emitTelemetrigram("load");
    }

    public handleSearchPreference(searchPreference: SearchPreference): void { }

    public handleSearchResults(results: any | null): void { }

    public search = (): void => {

        this.itemService.search(this.searchRequest).subscribe((result: any | null) => {

            if (result != null) {

                if (result instanceof HttpErrorResponse) {

                    this.appService.showDialog(MessageSeverity.Error, "API Error", "An error occurred searching " + this.itemTypeName + " results", "OK", "", true, true);

                } else {

                    this.searchResult = result;
                    this.searchResultDatasource = new MatTableDataSource(this.searchResult);
                    this.searchResultDatasource.sort = this.sort;
                }
            }
        });
    }

    public newItem(): void {

        this.appService.navigateTo(this.itemRoute + "/0", "");
    }

    public editItem(id: number) {

        const route: string = this.itemRoute + "/" + id.toString();
        this.appService.navigateTo(route, "");
    }

    public deleteItem(id: number, name: string) {

        this.appService.showDialog(MessageSeverity.Info, "Confirm Deletion", "You are about to delete " + this.itemTypeName + " " + name + ".  If you are absolutely sure, click DELETE, otherwise CANCEL to return to the page", "DELETE", "CANCEL", false, false).subscribe((response: string) => {

            if (response == "DELETE") {

                this.appService.IsAppBusy = true;

                this.itemService.delete(id).subscribe((r: DeleteResult | null) => {

                    if (r != null) {

                        if (r instanceof HttpErrorResponse) {

                            this.appService.IsAppBusy = false;
                            this.appService.showDialog(MessageSeverity.Error, "Error Deleting " + this.itemTypeName, "An error occurred deleting " + this.itemTypeName + " " + name, "OK", "", true, true);

                        } else {

                            const itemIndex: number | undefined = this.getItemIndexFromSearchResult(id);

                            if (itemIndex != undefined && itemIndex > -1) {

                                this.searchResult.splice(itemIndex, 1);
                                this.searchResultDatasource = new MatTableDataSource(this.searchResult);
                            }

                            this.appService.IsAppBusy = false;
                            this.appService.addAppFeedMessage(MessageSeverity.Info, "Successfully deleted " + this.itemTypeName + " " + name, true);
                        }
                    }
                });
            }
        });
    }

    public getItemIndexFromSearchResult(id: number): number | undefined {

        return -1; // extending class needs to override this and return the index of the item that matches the given id
    }

    public ngOnDestroy() {

        this.appService.setActionsDataSource([]);
        this.destroy.next();
        this.destroy.complete();
    }
}
